import React, { memo } from 'react';

import styles from '@/components/BottomNavigation/BottomNavigation.module.scss';
import BottomNavigationSlot from '@/components/BottomNavigation/BottomNavigationSlot';
import {
  BottomNavigationItem,
  BottomNavigationProps,
} from '@/components/BottomNavigation/types';
import GameLink from '@/components/GameLink';
import { ShouldPreventDefaultForClick } from '@/components/LaunchStrategiesProvider/utils';
import { DeviceOs } from '@/logic/main/types';

interface ItemGameProps {
  item: BottomNavigationItem;
  index: number;
  deviceType: 'mobile' | 'tablet' | 'desktop';
  deviceOs: DeviceOs;
  pageTitle?: string;
  onGameClick: BottomNavigationProps['onBottomNavigationGameClick'];
}

export const createRel = (item?: BottomNavigationItem) => {
  return `noopener noreferer ${item?.notIndexed ? 'nofollow' : ''}`;
};

const ItemGame: React.FC<ItemGameProps> = memo(
  ({ item, index, deviceOs, deviceType, pageTitle, onGameClick }) => {
    if (!item.game) return null;

    const preventDefaultForGameClick = ShouldPreventDefaultForClick(
      item.game.integration
    );

    const handleGameItemClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefaultForGameClick) e.preventDefault();
      onGameClick &&
        onGameClick({
          game: {
            ...item.game!,
            trackingTitle:
              item.game!.tracking_metadata?.title || item.game!.title,
          },
          itemTitle: item.title,
          sectionTitle: 'Bottom Nav',
          gamePosition: index + 1,
        });
    };

    return (
      <div className={styles.slot} key={index} data-testid="slot">
        <GameLink
          className={styles.link}
          notIndexed={item.notIndexed}
          url={item.game.launchUrl}
          integration={item.game.integration}
          onClick={handleGameItemClick}
          emptySpaceChar={false}
          categoryAttributes={{
            topCategory: pageTitle,
            title: 'bottom_navigation',
          }}
        >
          <BottomNavigationSlot item={item} />
        </GameLink>
      </div>
    );
  }
);

export default ItemGame;
